"use strict";
var debounce = require("lodash/debounce");

/**
 * @function
 * @description initializes long emails events on the confirmation page
 */
const initLongEmailEvents = () => {
    const $orderConfirmationEmail = $(".order-thank-you-email");

    $orderConfirmationEmail.each((i, el) => {
        const $this = $(el);
        const $parent = $this.closest(".order-thank-you-email-msg");

        $this.removeClass("js-ellipsis-applied");

        if ($parent.length > 0 && ($this.width() > $parent.width())) {
            $this.addClass("js-ellipsis-applied");
        } else {
            $this.removeClass("js-ellipsis-applied");
        }
    });
};

/**
 * @function
 * @description handles long emails on the confirmation page
 */
const handleLongEmail = () => {
    initLongEmailEvents();

    $(window).on("resize", debounce(() => {
        initLongEmailEvents();
    }, 100));
};


module.exports = handleLongEmail;
